import React from "react";
import { errorToast, successToast } from "./common/showtoast";
import ApiRequest from "./common/restservice";
import Swal from "sweetalert2";
import PageHeader from "./common/pageheader";

export default class Transfer extends React.Component {
  constructor(props) {
    super(props);
    console.log(props);
    this.state = {
      userid: "",
      amount: "",
      companywallet: "0",
      membername: "",
      fromDate: "",
      toDate: "",
      tableData: [],
      pinid: "",
      pinpass: ""
    }
  }

  componentDidMount() {
    if (this.props.match && this.props.match.params) {
      this.setState({
        pinid: this.props.match.params.pinid,
        pinpass: this.props.match.params.pinpass
      })
    }
  }
  // async GetTransactions() {
  //     let jsoninput = {
  //         fromdate: this.state.fromDate,
  //         todate: this.state.toDate
  //     }
  //     let url = "GetCompanyWallet.asp";
  //     let res = await ApiRequest(url,"POST",jsoninput,{Authorization : localStorage.getItem("token")});
  //     console.log(res);
  //     if (res.status === "error") {
  //         errorToast(res.message);
  //         if (res.message === "Session Expired") {
  //             localStorage.clear();
  //             this.props.history.push("/login");
  //         }
  //         this.setState({
  //             tableData: []
  //         })
  //         return;
  //     }
  //     this.setState({
  //         tableData: res.items
  //     })
  // }
  // async GetDashboardDetails() {
  //     let res = await ApiRequest("GetDashboardDetails.asp", "GET", null, { Authorization: localStorage.getItem("token") });
  //     console.log(res);
  //     if (res.status === "error") {
  //         errorToast(res.message);
  //         if (res.message === "Session Expired") {
  //             localStorage.removeItem("token");
  //             localStorage.removeItem("username");
  //             this.props.history.push("/login");
  //         }
  //         return;
  //     }
  //     this.setState({
  //         companywallet: res.availablecompanywallet
  //     });
  // }
  async onTransferConfirm(json) {
    let res = await ApiRequest("pintransfer.asp", "POST", json, { Authorization: localStorage.getItem("token") });
    if (res.status === "error") {
      errorToast(res.message);
      if (res.message === "Session Expired") {
        localStorage.removeItem("token");
        localStorage.removeItem("username");
        this.props.history.push("/login");
      }
      return { success: false, message: res.message };
    }
    successToast(res.message);
    return { success: true, message: "" }
  }
  async getName() {
    if (!this.state.userid) {
      return;
    }
    let jsoninput = {
      memberid: this.state.userid
    }
    let res = await ApiRequest("getname.asp", "POST", jsoninput, { Authorization: localStorage.getItem("token") });
    if (res.status === "error") {
      errorToast(res.message);
      if (res.message === "Session Expired") {
        localStorage.removeItem("token");
        localStorage.removeItem("username");
        this.props.history.push("/login");
      }
      return;
    }
    successToast(res.message);
    this.setState({
      membername: res.fullname
    })
  }
  render() {
    return (
      <div>
        <PageHeader title="Transfer" />
        <div className="row">
          <div className="col-xl-12 col-lg-12 col-md-12 col-xm-12">
            <div className="card overflow-hidden dash1-card border-0 ">
              <div className="card-body">
                <h3 className=" mt-3 mb-3 text-center">E-Pin Transfer</h3>
                <div className="col-lg-12 row mt-2">
                  <button className="col-lg-6 col-md-12 mt-2  btn btn-primary-color" type="button">User Id</button>
                  <input type="text" className=" mt-2 col-lg-6 col-md-12 form-control" placeholder="User id " aria-label="Amount" tabIndex="1" value={this.state.userid} onChange={(e) => {
                    this.setState({
                      userid: e.target.value
                    })
                  }} onBlur={() => this.getName()} />
                  <button className="col-lg-6 col-md-12 mt-2  btn btn-primary-color" type="button">User Name</button>
                  <input type="text" readOnly className=" mt-2 col-lg-6 col-md-12 form-control" placeholder="User name " aria-label="name" tabIndex="1" value={this.state.membername} />
                  <button className="col-lg-6 col-md-12 btn btn-primary-color mt-2" type="button">Pin id</button>
                  <input type="text" className="col-lg-6 col-md-12 form-control mt-2" placeholder="Pin id" aria-label="membername" tabIndex="1" value={this.state.pinid} onChange={(e) => {
                    this.setState({
                      pinid: e.target.value
                    })
                  }} />
                  <button className="col-lg-6 col-md-12 btn btn-primary-color mt-2" type="button">Pin Pass</button>
                  <input type="password" className="col-lg-6 col-md-12 form-control mt-2" placeholder="Pin pass" aria-label="Amount" tabIndex="1" value={this.state.pinpass} onChange={(e) => {
                    this.setState({
                      pinpass: e.target.value
                    })
                  }} />
                </div>
                <div className="col-lg-12 col-md-12 text-center" >
                  <button className="btn primebtn mt-5" onClick={async () => {
                    if (!this.state.userid) {
                      errorToast("Enter valid userid");
                      return;
                    } else if (!this.state.pinid) {
                      errorToast("Enter valid pinid");
                      return;
                    } else if (!this.state.pinpass) {
                      errorToast("Enter valid pinpass");
                      return;
                    }
                    await Swal.fire({
                      title: "Your transaction password",
                      input: "password",
                      inputLabel: "Your transaction password",
                      inputPlaceholder: "Enter your transaction password",
                      showCancelButton: true,
                      inputValidator: async (value) => {
                        if (!value) {
                          return "Please enter your transaction password or cancel!"
                        }
                        let t = {
                          pinid: this.state.pinid,
                          transferto: this.state.userid,
                          pinpass: this.state.pinpass,
                          tac: value
                        };
                        let sta = await this.onTransferConfirm(t);
                        if (!sta.success) {
                          return sta.message
                        }
                        await Swal.fire({
                          title: "Transferred Successfully",
                          icon: "success",
                          text: `Your pin ${this.state.pinid} has transferred successfully to User : ${this.state.userid}!`
                        });
                        this.setState({
                          userid: "",
                          amount: ""
                        });
                        this.props.history.goBack();
                      }
                    })
                  }}>Transfer</button>
                </div>
              </div>
            </div>
          </div>
        </div >
      </div >
    )
  }
}